import React from 'react';
import Slider from 'react-slick';
import image1 from '../img/envision/aerospace/cards/experiance.JPG';
import image2 from '../img/envision/aerospace/cards/expertsandadvesers.jpg';
import image3 from '../img/envision/aerospace/cards/fivestar-ratting.jpg';

const Homeanimatedcardsmobile = () => {
    const carouselItems = [
        {
            imgSrc: image1,
            altText: "image1",
            title: "DREBCON",
            description: "Built with each resource with an average of 25+ years of experience working with 200+ clients in 10 countries."
        },
        {
            imgSrc: image2,
            altText: "image2",
            title: "DREBCON",
            description: "Led by reputed experts and advisors with a proven track record across diverse sectors."
        },
        {
            imgSrc: image3,
            altText: "image3",
            title: "DREBCON",
            description: "Driven by years of expertise and a customer-centric vision."
        }
    ];

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
    };

    return (
        <div className="carousel-wrapper">
            <div className="slider-container">
                <Slider {...settings}>
                    {carouselItems.map((item, index) => (
                        <div className="slider" key={index}>
                            <div className="slider__item">
                                <img src={item.imgSrc} alt={item.altText} />
                            </div>

                            <div className="slider__description">
                                <h2>{item.title}</h2>
                                <p>{item.description}</p>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>

            <style jsx>{`
                .carousel-wrapper {
                    margin-top: 100px;
                    display: flex;
                    justify-content: center;
                }

                .slider-container {
                    width: 90%;
                    max-width: 400px;
                }

                .slider {
                    position: relative;
                    text-align: center;
                    padding: 20px;
                    background-color: #fff;
                    border-radius: 10px;
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                    height: 400px; /* Fixed height for uniform cards */
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: space-between;
                }

                .slider__item {
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-grow: 1;
                }

                .slider__item img {
                    max-width: 100%;
                    max-height: 200px; /* Ensures images don't exceed the fixed height */
                    object-fit: contain;
                    border-radius: 8px;
                }

                .slider__description {
                    margin-top: 10px;
                    width: 100%;
                }

                .slider__description h2 {
                    font-size: 1.5rem;
                    color: #333;
                }

                .slider__description p {
                    font-size: 1rem;
                    color: #555;
                    line-height: 1.4;
                }

                /* Mobile view adjustments */
                @media (max-width: 768px) {
                    .slider-container {
                        width: 95%;
                    }

                    .slider {
                        height: 380px; /* Adjusted for smaller screens */
                        padding: 15px;
                    }

                    .slider__description h2 {
                        font-size: 1.25rem;
                    }

                    .slider__description p {
                        font-size: 0.9rem;
                    }
                }

                @media (max-width: 480px) {
                    .slider {
                        height: 350px;
                        padding: 10px;
                    }

                    .slider__description h2 {
                        font-size: 1rem;
                    }

                    .slider__description p {
                        font-size: 0.85rem;
                    }

                    .slider__item img {
                        max-height: 180px;
                    }
                }
            `}</style>
        </div>
    );
};

export default Homeanimatedcardsmobile;
